// extracted by mini-css-extract-plugin
export default {"cls1":"StickyCtaFooter-cls1_i4P","cls2":"StickyCtaFooter-cls2_ghC StickyCtaFooter-cls1_i4P"};